module.exports = __webpack_public_path__ + "static/media/gcash-success.6860faee.png";